export default __webpack_public_path__ + "static/img/LoginImage1.2f0e911.png";